(function () {
  'use strict';
  if (window.FlorameWelcome) return;
  var config = document.getElementById('florameWelcomeLoader');
  if (!config) return;
  var seenKey = 'florame_welcome_seen_v1';
  var loading = null, v2StyleLoading = null, v3Loading = null, v4Loading = null, stopped = false, timer = 0, observer = null, opening = false, started = Date.now();
  function seen() { try { return !!localStorage.getItem(seenKey); } catch (_) { return !!window.__florameWelcomeSeen; } }
  function busy() {
    return document.visibilityState === 'hidden' || !!document.querySelector('dialog[open], .fac.is-open, [data-florame-account-center]:not([hidden])')
      || ['shopify-pc__banner', 'shopify-pc__prefs__dialog'].some(function (id) {
        var el = document.getElementById(id);
        return el && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && el.getAttribute('aria-hidden') !== 'true';
      }) || document.body.classList.contains('florame-delivery-intent-open')
      || document.documentElement.classList.contains('florame-home-intro-active');
  }
  function stopAuto() { stopped = true; clearTimeout(timer); if (observer) observer.disconnect(); }
  function load() {
    if (loading) return loading;
    loading = new Promise(function (resolve, reject) {
      var existingStyle = document.getElementById('florameWelcomeStyle');
      var link = existingStyle?.sheet ? existingStyle : document.createElement('link');
      if (link !== existingStyle) { link.rel = 'stylesheet'; link.href = config.dataset.style; }
      var script = document.createElement('script'); script.src = config.dataset.runtime;
      var loaded = link === existingStyle ? 1 : 0, settled = false, timeout = setTimeout(failed, 12000);
      function ready() { if (!settled && ++loaded === 2) { settled = true; clearTimeout(timeout); resolve(); } }
      function failed() { if (settled) return; settled = true; clearTimeout(timeout); if (link !== existingStyle) link.remove(); script.remove(); loading = null; reject(new Error('welcome_load_failed')); }
      if (link !== existingStyle) { link.onload = ready; link.onerror = failed; document.head.appendChild(link); }
      script.onload = ready; script.onerror = failed; document.head.appendChild(script);
    });
    return loading;
  }
  async function open(options) {
    options = options || {};
    if (opening) return;
    opening = true;
    if (!options.automatic) stopAuto();
    var trigger = options.trigger || document.activeElement;
    var version = options.version || trigger?.dataset?.florameWelcomeVersion || (config.dataset.runtimeV4 ? 'v4' : config.dataset.runtimeV3 ? 'v3' : 'v1');
    try {
      if (version === 'v4') await loadV4(); else if (version === 'v3') await loadV3(); else await load();
      if (version === 'v2') await loadV2Style();
      if (!options.automatic || (!seen() && !busy())) {
        var account = document.querySelector('[data-florame-account-center]:not([hidden])');
        if (!options.resume) window.FlorameAccountCenter?.close?.();
        if (account && !options.resume) await new Promise(function (resolve, reject) {
          var deadline = Date.now() + 1500;
          function settled() {
            if (account.hidden) return resolve();
            if (Date.now() > deadline) return reject(new Error('account_close_timeout'));
            setTimeout(settled, 20);
          }
          settled();
        });
        var experience = version === 'v4' ? window.FlorameWelcomeV4 : version === 'v3' ? window.FlorameWelcomeV3 : window.FlorameWelcomeExperience;
        experience.open({ config: config.dataset, trigger: trigger, version: version, automatic: options.automatic === true, resume: options.resume === true });
        stopAuto();
      }
    } catch (_) {
      if (trigger && trigger.matches?.('[data-florame-welcome-open]')) {
        trigger.removeAttribute('aria-busy');
        var label = trigger.querySelector('small, em');
        if (!label) { label = document.createElement('small'); trigger.querySelector('.fac__row-copy')?.appendChild(label); }
        if (label) label.textContent = /^en/i.test(document.documentElement.lang) ? 'Unable to load. Tap to retry.' : 'Caricamento non riuscito. Tocca per riprovare.';
      }
      if (options.automatic) stopAuto();
    } finally { opening = false; trigger?.removeAttribute?.('aria-busy'); schedule(); }
  }
  function loadV4() {
    if (v4Loading) return v4Loading;
    v4Loading = new Promise(function (resolve, reject) {
      var style = document.createElement('link'), script = document.createElement('script'), count = 0, done = false;
      style.rel = 'stylesheet'; style.href = config.dataset.styleV4; script.src = config.dataset.runtimeV4;
      var timeout = setTimeout(failed, 12000);
      function failed() { if (done) return; done = true; clearTimeout(timeout); style.remove(); script.remove(); v4Loading = null; reject(new Error('welcome_v4_load_failed')); }
      function ready() { if (done || ++count !== 2) return; done = true; clearTimeout(timeout); resolve(); }
      style.onload = script.onload = ready; style.onerror = script.onerror = failed;
      document.head.appendChild(style); document.head.appendChild(script);
    });
    return v4Loading;
  }
  function loadV3() {
    if (v3Loading) return v3Loading;
    v3Loading = new Promise(function (resolve, reject) {
      var style = document.createElement('link'), script = document.createElement('script'), count = 0, done = false;
      style.rel = 'stylesheet'; style.href = config.dataset.styleV3; script.src = config.dataset.runtimeV3;
      var timeout = setTimeout(failed, 12000);
      function failed() { if (done) return; done = true; clearTimeout(timeout); style.remove(); script.remove(); v3Loading = null; reject(new Error('welcome_v3_load_failed')); }
      function ready() { if (done || ++count !== 2) return; done = true; clearTimeout(timeout); resolve(); }
      style.onload = script.onload = ready; style.onerror = script.onerror = failed;
      document.head.appendChild(style); document.head.appendChild(script);
    });
    return v3Loading;
  }
  function loadV2Style() {
    if (v2StyleLoading) return v2StyleLoading;
    v2StyleLoading = new Promise(function (resolve, reject) {
      var style = document.createElement('link'), done = false;
      style.rel = 'stylesheet'; style.href = config.dataset.styleV2;
      var timeout = setTimeout(failed, 12000);
      function failed() { if (done) return; done = true; clearTimeout(timeout); style.remove(); v2StyleLoading = null; reject(new Error('welcome_v2_style_failed')); }
      style.onload = function () { if (done) return; done = true; clearTimeout(timeout); resolve(); };
      style.onerror = failed; document.head.appendChild(style);
    });
    return v2StyleLoading;
  }
  window.FlorameWelcome = { open: open };
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-florame-welcome-open]');
    if (!trigger) return;
    event.preventDefault(); trigger.setAttribute('aria-busy', 'true'); open({ trigger: trigger });
  });
  function schedule() {
    if (stopped || seen() || timer || opening) return;
    timer = setTimeout(function () {
      timer = 0;
      if (stopped || seen()) { stopAuto(); return; }
      // Wait for Shopify's privacy decision; never put two introductions on top of each other.
      var privacy = window.Shopify?.customerPrivacy;
      // Shopify may report shouldShowBanner even when the merchant renders no banner.
      // Give its UI time to mount, then defer to visible consent surfaces, not that flag forever.
      var privacyPending = (window.Shopify && !privacy) || privacy?.shouldShowBanner?.() === true;
      if (busy() || (privacyPending && Date.now() - started < 6000)) { schedule(); return; }
      open({ automatic: true });
    }, 1200);
  }
  var params = new URLSearchParams(location.search);
  // V3 is now a short introduction, not a coach that resumes on commerce pages.
  try { sessionStorage.removeItem('florame_first_order_v3'); } catch (_) {}
  var collection = params.get('f') || params.get('view') || params.get('filter') || params.get('type');
  if (config.dataset.auto === 'true' && config.dataset.designMode !== 'true' && !seen()
    && !params.has('florame_bg_job') && !['mine', 'liked', 'favorites'].includes(collection)) {
    observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-hidden'] });
    document.addEventListener('visitorConsentCollected', schedule);
    document.addEventListener('visibilitychange', schedule);
    window.addEventListener('pagehide', stopAuto, { once: true });
    schedule();
  }
  // A replay can finish on another page; carry only this short visual arrival to Home.
  try {
    var arrival = Number(sessionStorage.getItem('florame_welcome_arrival_v1'));
    if (config.dataset.auto === 'true' && arrival) {
      sessionStorage.removeItem('florame_welcome_arrival_v1');
      var hero = document.querySelector('[data-florame-cinematic-hero]');
      if (Date.now() - arrival < 20000 && hero && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        hero.animate([{ opacity: .3, transform: 'translateY(22px) scale(.98)' }, { opacity: 1, transform: 'none' }], { duration: 800, easing: 'cubic-bezier(.2,.75,.2,1)' });
      }
    }
  } catch (_) {}
})();
